// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor2 from '@/game/prefabs/World/Mentors/Mentor2';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from '@/game/scenes/TilemapScenes/TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level31 extends TilemapScene {
  constructor() {
    super('Level31');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // spring_biome_8
    const spring_biome_8 = this.add.tilemap('spring-biome-8');
    spring_biome_8.addTilesetImage(
      'spring forest wang tiles',
      'spring forest wang tiles',
    );
    spring_biome_8.addTilesetImage(
      'spring water sparkles B',
      'spring water sparkles B',
    );
    spring_biome_8.addTilesetImage('spring forest', 'spring forest');

    // tilemapLayer
    const tilemapLayer = this.add.container(1, 0);

    // wang_Terrain_1
    const wang_Terrain_1 = spring_biome_8.createLayer(
      'Wang Terrain',
      ['spring forest wang tiles'],
      0,
      0,
    )!;
    tilemapLayer.add(wang_Terrain_1);

    // sparkles_1
    const sparkles_1 = spring_biome_8.createLayer(
      'Sparkles',
      ['spring water sparkles B'],
      0,
      0,
    )!;
    tilemapLayer.add(sparkles_1);

    // rocks_1
    const rocks_1 = spring_biome_8.createLayer(
      'Rocks',
      ['spring forest'],
      0,
      0,
    )!;
    tilemapLayer.add(rocks_1);

    // player
    const player = new Player(this, 349, 506);
    this.add.existing(player);

    // mentor2
    const mentor2 = new Mentor2(this, 401, 451);
    this.add.existing(mentor2);

    // portal
    const portal = new Portal(this, 342, 430);
    this.add.existing(portal);

    // worldNode
    const worldNode = new WorldNode(this, 122, 321);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 158, 216);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 111, 86);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 578, 70);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 522, 321);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 309, 128);
    this.add.existing(worldNode_5);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 582, 398);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 435, 427);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 220, 394);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 472, 159);
    this.add.existing(worldNode_9);

    // forestTree_58
    const forestTree_58 = new ForestTree1(this, 202, 151, 'spring 32x', 0);
    this.add.existing(forestTree_58);

    // forestTree_59
    const forestTree_59 = new ForestTree1(this, 81, 97, 'spring 32x', 0);
    this.add.existing(forestTree_59);

    // forestTree_60
    const forestTree_60 = new ForestTree1(this, 296, 48, 'spring 32x', 0);
    this.add.existing(forestTree_60);

    // forestTree_61
    const forestTree_61 = new ForestTree1(this, 592, 143, 'spring 32x', 0);
    this.add.existing(forestTree_61);

    // forestTree_62
    const forestTree_62 = new ForestTree1(this, 489, 364, 'spring 32x', 0);
    this.add.existing(forestTree_62);

    // forestTree_63
    const forestTree_63 = new ForestTree1(this, 523, 510, 'spring 32x', 0);
    this.add.existing(forestTree_63);

    // forestTree_64
    const forestTree_64 = new ForestTree1(this, 163, 415, 'spring 32x', 0);
    this.add.existing(forestTree_64);

    // forestTree_65
    const forestTree_65 = new ForestTree1(this, 50, 270, 'spring 32x', 0);
    this.add.existing(forestTree_65);

    // forestTree_66
    const forestTree_66 = new ForestTree1(this, 202, 491, 'spring 16x32', 5);
    this.add.existing(forestTree_66);

    // forestTree_67
    const forestTree_67 = new ForestTree1(this, 450, 332, 'spring 16x32', 5);
    this.add.existing(forestTree_67);

    // forestTree_68
    const forestTree_68 = new ForestTree1(this, 435, 113, 'spring 16x32', 5);
    this.add.existing(forestTree_68);

    // forestTree_69
    const forestTree_69 = new ForestTree1(this, 164, 49, 'spring 16x32', 5);
    this.add.existing(forestTree_69);

    // forestTree_70
    const forestTree_70 = new ForestTree1(this, 124, 180, 'spring 32x', 1);
    this.add.existing(forestTree_70);

    // forestTree_71
    const forestTree_71 = new ForestTree1(this, 183, 213, 'spring 16x32', 5);
    this.add.existing(forestTree_71);

    // forestTree_72
    const forestTree_72 = new ForestTree1(this, 611, 204, 'spring 16x32', 5);
    this.add.existing(forestTree_72);

    // forestTree_73
    const forestTree_73 = new ForestTree1(this, 582, 435, 'spring 16x32', 5);
    this.add.existing(forestTree_73);

    // forestTree_74
    const forestTree_74 = new ForestTree1(this, 582, 435, 'spring 16x32', 4);
    this.add.existing(forestTree_74);

    // forestTree_75
    const forestTree_75 = new ForestTree1(this, 83, 306, 'spring 16x32', 4);
    this.add.existing(forestTree_75);

    // forestTree_76
    const forestTree_76 = new ForestTree1(this, 411, 36, 'spring 16x32', 4);
    this.add.existing(forestTree_76);

    // forestTree_77
    const forestTree_77 = new ForestTree1(this, 507, 193, 'spring 16x32', 4);
    this.add.existing(forestTree_77);

    // forestTree_78
    const forestTree_78 = new ForestTree1(this, 507, 67, 'spring 32x', 1);
    this.add.existing(forestTree_78);

    // forestTree_79
    const forestTree_79 = new ForestTree1(this, 227, 504, 'spring 32x', 1);
    this.add.existing(forestTree_79);

    // forestTree_80
    const forestTree_80 = new ForestTree1(this, 547, 222, 'spring 32x', 1);
    this.add.existing(forestTree_80);

    // forestTree_81
    const forestTree_81 = new ForestTree1(this, 311, 179, 'spring 32x', 6);
    this.add.existing(forestTree_81);

    // forestTree_82
    const forestTree_82 = new ForestTree1(this, 308, 384, 'spring 32x', 6);
    this.add.existing(forestTree_82);

    // forestTree_83
    const forestTree_83 = new ForestTree1(this, 416, 257, 'spring 32x', 6);
    this.add.existing(forestTree_83);

    // forestTree1
    const forestTree1 = new ForestTree1(
      this,
      154,
      553,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree1);

    // forestTree_44
    const forestTree_44 = new ForestTree1(
      this,
      199,
      311,
      'spring trees 80x112',
      2,
    );
    this.add.existing(forestTree_44);

    // forestTree
    const forestTree = new ForestTree1(
      this,
      216,
      337,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      522,
      308,
      'spring trees 80x112',
      2,
    );
    this.add.existing(forestTree_1);

    // forestTree_34
    const forestTree_34 = new ForestTree1(
      this,
      15,
      358,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_34);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      19,
      444,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_11);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      8,
      259,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      -9,
      379,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_6);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      -15,
      448,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      49,
      480,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      47,
      534,
      'spring trees 80x112',
      2,
    );
    this.add.existing(forestTree_10);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      64,
      558,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_7);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      8,
      515,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_4);

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      98,
      536,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_3);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      10,
      29,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      44,
      48,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      129,
      24,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      237,
      25,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      279,
      18,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      354,
      28,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      419,
      22,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(
      this,
      481,
      36,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(
      this,
      583,
      20,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(
      this,
      660,
      72,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(
      this,
      632,
      157,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_22);

    // forestTree_32
    const forestTree_32 = new ForestTree1(
      this,
      665,
      155,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_32);

    // forestTree_55
    const forestTree_55 = new ForestTree1(
      this,
      606,
      518,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_55);

    // forestTree_23
    const forestTree_23 = new ForestTree1(
      this,
      669,
      231,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(
      this,
      7,
      63,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_24);

    // forestTree_43
    const forestTree_43 = new ForestTree1(
      this,
      20,
      322,
      'spring trees 80x112',
      2,
    );
    this.add.existing(forestTree_43);

    // forestTree_25
    const forestTree_25 = new ForestTree1(
      this,
      90,
      26,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(
      this,
      163,
      23,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(
      this,
      309,
      15,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(
      this,
      388,
      24,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_28);

    // forestTree_29
    const forestTree_29 = new ForestTree1(
      this,
      451,
      34,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_29);

    // forestTree_30
    const forestTree_30 = new ForestTree1(
      this,
      547,
      20,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_30);

    // forestTree_31
    const forestTree_31 = new ForestTree1(
      this,
      602,
      53,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_31);

    // forestTree_33
    const forestTree_33 = new ForestTree1(
      this,
      -16,
      271,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_33);

    // forestTree_35
    const forestTree_35 = new ForestTree1(
      this,
      519,
      32,
      'spring trees 80x112',
      2,
    );
    this.add.existing(forestTree_35);

    // forestTree_36
    const forestTree_36 = new ForestTree1(
      this,
      209,
      16,
      'spring trees 80x112',
      2,
    );
    this.add.existing(forestTree_36);

    // forestTree_37
    const forestTree_37 = new ForestTree1(
      this,
      75,
      40,
      'spring trees 80x112',
      2,
    );
    this.add.existing(forestTree_37);

    // forestTree_38
    const forestTree_38 = new ForestTree1(
      this,
      7,
      106,
      'spring trees 80x112',
      2,
    );
    this.add.existing(forestTree_38);

    // forestTree_39
    const forestTree_39 = new ForestTree1(
      this,
      237,
      145,
      'spring trees 80x112',
      2,
    );
    this.add.existing(forestTree_39);

    // forestTree_40
    const forestTree_40 = new ForestTree1(
      this,
      669,
      267,
      'spring trees 80x112',
      2,
    );
    this.add.existing(forestTree_40);

    // forestTree_41
    const forestTree_41 = new ForestTree1(
      this,
      629,
      87,
      'spring trees 80x112',
      2,
    );
    this.add.existing(forestTree_41);

    // forestTree_45
    const forestTree_45 = new ForestTree1(
      this,
      53,
      72,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_45);

    // forestTree_46
    const forestTree_46 = new ForestTree1(
      this,
      6,
      140,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_46);

    // forestTree_47
    const forestTree_47 = new ForestTree1(
      this,
      556,
      51,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_47);

    // forestTree_48
    const forestTree_48 = new ForestTree1(
      this,
      657,
      287,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_48);

    // forestTree_54
    const forestTree_54 = new ForestTree1(
      this,
      664,
      338,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_54);

    // forestTree_42
    const forestTree_42 = new ForestTree1(
      this,
      631,
      372,
      'spring trees 80x112',
      2,
    );
    this.add.existing(forestTree_42);

    // forestTree_49
    const forestTree_49 = new ForestTree1(
      this,
      655,
      409,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_49);

    // forestTree_50
    const forestTree_50 = new ForestTree1(
      this,
      655,
      409,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_50);

    // forestTree_51
    const forestTree_51 = new ForestTree1(
      this,
      585,
      579,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_51);

    // forestTree_52
    const forestTree_52 = new ForestTree1(
      this,
      -31,
      199,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_52);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      644,
      508,
      'spring trees 80x112',
      0,
    );
    this.add.existing(forestTree_2);

    // forestTree_53
    const forestTree_53 = new ForestTree1(
      this,
      646,
      556,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_53);

    // forestTree_56
    const forestTree_56 = new ForestTree1(
      this,
      7,
      166,
      'spring trees 80x112',
      1,
    );
    this.add.existing(forestTree_56);

    // forestTree_57
    const forestTree_57 = new ForestTree1(
      this,
      157,
      209,
      'spring trees 80x112',
      2,
    );
    this.add.existing(forestTree_57);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 30;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 30;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 30;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 30;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 30;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 30;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 30;
    worldNode_6.NPCId = 6;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 30;
    worldNode_7.NPCId = 7;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 30;
    worldNode_8.NPCId = 8;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 30;
    worldNode_9.NPCId = 9;

    this.player = player;
    this.mentor2 = mentor2;
    this.portal = portal;
    this.worldNode = worldNode;
    this.worldNode_1 = worldNode_1;
    this.worldNode_2 = worldNode_2;
    this.worldNode_3 = worldNode_3;
    this.worldNode_4 = worldNode_4;
    this.worldNode_5 = worldNode_5;
    this.worldNode_6 = worldNode_6;
    this.worldNode_7 = worldNode_7;
    this.worldNode_8 = worldNode_8;
    this.worldNode_9 = worldNode_9;
    this.spring_biome_8 = spring_biome_8;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private mentor2!: Mentor2;
  private portal!: Portal;
  private worldNode!: WorldNode;
  private worldNode_1!: WorldNode;
  private worldNode_2!: WorldNode;
  private worldNode_3!: WorldNode;
  private worldNode_4!: WorldNode;
  private worldNode_5!: WorldNode;
  private worldNode_6!: WorldNode;
  private worldNode_7!: WorldNode;
  private worldNode_8!: WorldNode;
  private worldNode_9!: WorldNode;
  private spring_biome_8!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.spring_biome_8,
      portal: this.portal,
      mentor: this.mentor2,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
